import React from 'react';
import { Box, Typography } from '@mui/material';
import TentativasTable from '../components/sincronizacao/TentativasTable';

const SincronizacaoVisualizarStatus: React.FC = () => {
  return (
    <Box>
      <TentativasTable />
    </Box>
  );
};

export default SincronizacaoVisualizarStatus;
